/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled               from 'styled-components';
import PropTypes            from 'prop-types';
import { transparentize }   from 'polished';
import { Colours, Spacing } from '../../../styles/variables';
import { Media }            from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledNavigationList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  background: ${transparentize(0.03, Colours.Tundora)};
  display: ${props => props.isNavigationOpen ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  li {
    width: inherit;
  }
  ${Media.Tablet`
    display: flex;
    background: transparent;
    height: auto;
    position: static;
    flex-direction: row;
    justify-content: flex-end;
    flex: 1;
    li {
      margin-left: ${Spacing.Small};
      width: auto;
    }
  `}
`;

StyledNavigationList.propTypes = {
    isNavigationOpen: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/atoms/StyledNavigationList/index.js